// import differenceInCalendarWeeks from 'date-fns/differenceInCalendarWeeks';
import startOfWeek from 'date-fns/startOfWeek';
import startOfDay from 'date-fns/startOfDay';
import subWeeks from 'date-fns/subWeeks';

export const getConfiguredCauses = (elementTypes, taskTypeId) => {
  const e = elementTypes.get(taskTypeId);
  const props = e.get('props');
  return props.getIn(['Status', '_typeOptions', 'reasons']).toArray();
}

export const getRootCauseData = (reports, causes) => {
  // Create a map of the current categories
  const causeMap = {};
  causes.forEach(cause => causeMap[cause] = 0);

  // Generate the weekly bucket data
  const dailyBucketMap = {};
  const weeklyBucketMap = {};
  reports.forEach(r => {
    // Update weekly bucket
    let today = r.getIn(['config', 'today']);
    today = startOfDay(today);
    // Skip if today has already been processed
    if (dailyBucketMap[today]) return;
    dailyBucketMap[today] = true;
    const weekDate = startOfWeek(today,  { weekStartsOn: 1 }).getTime();
    if (!weeklyBucketMap[weekDate]) weeklyBucketMap[weekDate] = { taskCount: 0 };
    const bucket = weeklyBucketMap[weekDate];

    // update list of causes if a new cause is found
    const blocked = r.getIn(['config', 'blocked']);
    if (!blocked) return;
    blocked.keySeq().forEach(cause => {
      if (causeMap[cause] === undefined) {
        causeMap[cause] = 0;
        causes.push(cause);
      }
      const val = blocked.get(cause);
      bucket[cause] = (bucket[cause]) ? bucket[cause] + val : val;
    });
  });

  // Generate values for graph
  let maxTasks = 10;    // keep track of max tasks in each weekly tick
  const weeklyBucketKeys = Object.keys(weeklyBucketMap).sort();
  const values = causes.map(cause => {
    const causeData = [];
    weeklyBucketKeys.forEach(key => {
      const bucket = weeklyBucketMap[key];
      const val = (bucket[cause]) ? bucket[cause] : 0;
      causeData.push({ week: new Date(parseInt(key,10)), tasks: val, label: cause });
      causeMap[cause] = causeMap[cause] + val; // maintain task count for cause
      weeklyBucketMap[key].taskCount += val;   // maintain task count for each weekly tick
      if (weeklyBucketMap[key].taskCount > maxTasks) {
        maxTasks = weeklyBucketMap[key].taskCount;
      }
    });
    return causeData;
  });

  // Generate tick values for graph
  const tickValues = weeklyBucketKeys.map(key => new Date(parseInt(key,10)));

  // Insert empty space at the start
  const firstWeek = tickValues[0];
  const prevWeek = subWeeks(firstWeek, 1);
  tickValues.unshift(prevWeek);
  values.forEach(value => {
    value.unshift({ week: prevWeek, tasks: 0, label: ''})
  });

  // Done
  return { categories: causes, values, tickValues, maxTasks };
}



// WEBPACK FOOTER //
// ./src/views/Project/RootCauseGraph/RootCauseData.js